// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"24dac4b586f5fc6832a8","883":"2e72af3cd47498335944"}[chunkId] + ".js";
};